export default "__VITE_ASSET__BlRIxfhJ__"